import { ImgID } from "../../image_loader/img_id.js";
import { ColorScheme } from "../common_ui_elements/color_scheme.js";
import { TextStyleScheme } from "../common_ui_elements/text_style_scheme.js";
import { UIImage } from "../common_ui_elements/ui_image.js";
import { UINineSliceElement } from "../common_ui_elements/ui_nine_slice_element.js";
import { MyTextAlign, MyTextVerticalAlign, UITextElement } from "../common_ui_elements/ui_text_element.js";
import { AbstractTooltip } from "./abstract_tooltip.js";

export class SoonTooltip extends AbstractTooltip
{
  private static readonly DESIGN_W = 370;
  private static readonly DESIGN_H = 160;
  private static readonly DESIGN_TAIL_W = 111;
  private static readonly DESIGN_TAIL_H = 78;
  private static readonly DESIGN_TAIL_Y_OFFSET = -32;
  private static readonly DESIGN_TAIL_X = 90;
  private static readonly DESIGN_FONT_SIZE = 45;
  private static readonly VISIBLE_MS = 2000;

  private close_at = 0;
  private readonly on_expire: () => void;

  public static create(
    ctx: CanvasRenderingContext2D,
    anchor_x: number,
    anchor_top: number,
    on_expire: () => void
  ): SoonTooltip
  {
    const w = LayoutScaler.widthFromDesign( SoonTooltip.DESIGN_W );
    const h = LayoutScaler.heightFromDesign( SoonTooltip.DESIGN_H );
    const tail_h = LayoutScaler.heightFromDesign( SoonTooltip.DESIGN_TAIL_H );
    const tail_y_offset = LayoutScaler.heightFromDesign( SoonTooltip.DESIGN_TAIL_Y_OFFSET );
    const tail_x = LayoutScaler.widthFromDesign( SoonTooltip.DESIGN_TAIL_X );

    const x = anchor_x - tail_x;
    const y = anchor_top - ( h + tail_y_offset + tail_h );

    return new SoonTooltip( ctx, x, y, w, h, tail_x, on_expire );
  }

  private constructor(
    ctx: CanvasRenderingContext2D,
    x: number,
    y: number,
    w: number,
    h: number,
    tail_x: number,
    on_expire: () => void
  )
  {
    super( ctx, x, y, w, h );

    this.on_expire = on_expire;

    const substrate = new UINineSliceElement( ctx, 0, 0, w, h, ImgID.UI_TutorialSubstrate, "tutorial_substrate" );
    this.addChild( substrate, true );

    const text = new UITextElement( ctx, 0, 0, w, h, {
      localization_key: "NAVIGATION.SOON",
      font_size: LayoutScaler.textSizeFromDesign( SoonTooltip.DESIGN_FONT_SIZE ),
      font_weight: 900,
      text_color: ColorScheme.tooltip_text_outline,
      text_style: TextStyleScheme.rubik,
      text_align: MyTextAlign.Center,
      vertical_align: MyTextVerticalAlign.Center,
      outline_color: ColorScheme.white,
      outline_width: LayoutScaler.textBorderSizeFromDesign( 5 ),
      auto_wrap: false,
      shadow_offset_x: 0,
      shadow_offset_y: 0
    } );
    substrate.addChild( text, true );

    const tail_w = LayoutScaler.widthFromDesign( SoonTooltip.DESIGN_TAIL_W );
    const tail_h = LayoutScaler.heightFromDesign( SoonTooltip.DESIGN_TAIL_H );
    const tail_left = tail_x - tail_w / 2;
    const tail_top = h + LayoutScaler.heightFromDesign( SoonTooltip.DESIGN_TAIL_Y_OFFSET );
    const tail = new UIImage( ctx, tail_left, tail_top, tail_w, tail_h, ImgID.UI_TooltipArrow );
    this.addChild( tail, true );
  }

  public update( now: number ): void
  {
    super.update( now );

    if ( this.close_at === 0 )
      this.close_at = now + SoonTooltip.VISIBLE_MS;
    else if ( now >= this.close_at )
      this.on_expire();
  }

  public name(): string
  {
    return "SoonTooltip";
  }

  public render(): void
  {
    if ( !this.shouldBeRendered() )
      return;

    this.startRender();
    this.finishRender();
  }
}
